import React from 'react';
import { EightDReport, UpdateFieldFn } from '../../types/eightd.types';
import { D0Preparation } from './D0Preparation';
import { D1TeamFormation } from './D1TeamFormation';
import { D1ProblemDescription, D2Containment } from '../EightDComponents';
import { D3RootCauseComponent, D4CorrectiveActions, D5Validation } from '../EightDComponentsPart2';
import { D6PreventiveActions, D7Recognition, D8Closure } from '../EightDComponentsPart3';

interface EightDTabContentProps {
    activeTab: number;
    report: Partial<EightDReport>;
    updateField: UpdateFieldFn;
    setReport: React.Dispatch<React.SetStateAction<Partial<EightDReport>>>;
}

export const EightDTabContent: React.FC<EightDTabContentProps> = ({
    activeTab,
    report,
    updateField,
    setReport,
}) => {
    return (
        <div className="bg-white rounded-b-xl border border-gray-200 border-t-0 p-6">
            {activeTab === 0 && <D0Preparation report={report} updateField={updateField} />}
            {activeTab === 1 && <D1TeamFormation report={report} updateField={updateField} />}

            {/* Note: We map D2 UI to D1 data, D3 UI to D2 data, etc to maintain DB schema while fixing GUI numbering */}
            <div className={activeTab === 2 ? 'block' : 'hidden'}>
                <div className="mb-4 p-3 bg-blue-50 text-blue-800 rounded-lg text-sm border border-blue-200">
                    <strong>Compliance Note:</strong> Defining the problem description using Is/Is Not Analysis.
                </div>
                <D1ProblemDescription report={report} updateField={updateField} />
            </div>

            <div className={activeTab === 3 ? 'block' : 'hidden'}>
                <div className="mb-4 p-3 bg-blue-50 text-blue-800 rounded-lg text-sm border border-blue-200">
                    <strong>Compliance Note:</strong> Interim Containment Actions (ICA) to protect the customer immediately.
                </div>
                <D2Containment report={report} updateField={updateField} setReport={setReport} />
            </div>

            <div className={activeTab === 4 ? 'block' : 'hidden'}>
                <div className="mb-4 p-3 bg-blue-50 text-blue-800 rounded-lg text-sm border border-blue-200">
                    <strong>Compliance Note:</strong> Root Cause Analysis (RCA) & Escape Points.
                </div>
                <D3RootCauseComponent report={report} updateField={updateField} setReport={setReport} />
            </div>

            <div className={activeTab === 5 ? 'block' : 'hidden'}>
                <div className="mb-4 p-3 bg-blue-50 text-blue-800 rounded-lg text-sm border border-blue-200">
                    <strong>Compliance Note:</strong> Select Permanent Corrective Actions (PCA).
                </div>
                <D4CorrectiveActions report={report} updateField={updateField} setReport={setReport} />
            </div>

            <div className={activeTab === 6 ? 'block' : 'hidden'}>
                <div className="mb-4 p-3 bg-blue-50 text-blue-800 rounded-lg text-sm border border-blue-200">
                    <strong>Compliance Note:</strong> Implement and Validate Permanent Corrective Actions.
                </div>
                <D5Validation report={report} updateField={updateField} />
            </div>

            <div className={activeTab === 7 ? 'block' : 'hidden'}>
                <div className="mb-4 p-3 bg-blue-50 text-blue-800 rounded-lg text-sm border border-blue-200">
                    <strong>Compliance Note:</strong> Prevent Recurrence (Update FMEA / Control Plan).
                </div>
                <D6PreventiveActions report={report} updateField={updateField} setReport={setReport} />
            </div>

            {activeTab === 8 && <D7Recognition report={report} updateField={updateField} />}
            {activeTab === 9 && <D8Closure report={report} updateField={updateField} />}
        </div>
    );
};
